import { initContract } from '@ts-rest/core';
import { authPlayerPreferencesContract } from './playerPreferences.auth.contract';

const c = initContract();

export const playerPreferencesContract = c.router(
  {
    auth: authPlayerPreferencesContract,
  },
  {
    pathPrefix: '/player/preferences',
    strictStatusCodes: true,
  }
);

export * from './models';
export * from './playerPreferences.auth.contract';

